
import { defineComponent } from 'vue'
import TaskCardActionForm from '@/components/TaskCardActionForm.vue'
import { copyTaskService } from '@/services/task'
export default defineComponent({
  inject: ['task', 'list'],
  components: {
    TaskCardActionForm
  },
  data () {
    return {
      keep: {
        task: '',
        attachments: true,
        comments: true,
        members: true,
        labels: true
      }
    }
  },
  methods: {
    async handleCopySubmit (payload: Record<string, string>) {
      const res = await copyTaskService(
        this.$route.params.boardId,
        payload.toBoardId,
        this.list._id,
        payload.toListId,
        this.task._id,
        this.keep
      )
      if (!res.error) {
        this.$store.commit('COPY_CURRENTBOARD_LIST_TASK', {
          toListId: payload.toListId,
          taskId: this.task._id
        })
        this.$emit('close')
      }
    }
  },
  computed: {
    keeps () {
      return {
        members: this.task.members.length,
        labels: this.task.labels.length,
        attachments: this.task.attachments.length,
        comments: this.task.comments.length
      }
    },
    showKeeps () {
      return Object.keys(this.keeps).some((kp) => !!this.keeps[kp])
    }
  }
})
